import React, { useState, useEffect } from "react";
import DiscountRuleModal from "./DiscountRuleModal";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Loader from "../Loader/Loader";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { invalidateInvoiceCatalog } from "../../utilis/invoiceWorkspaceApi";

function DiscountRule() {
  const [filterStatus, setFilterStatus] = useState("all");
  const [getLoading, setGetLoading] = useState(false);
  const [discount, setDiscount] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [counts, setCounts] = useState({
    total: 0,
    active: 0,
    inactive: 0,
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    percentage: "",
    is_active: true,
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    total: 0,
    lastPage: 1,
  });
  useEffect(() => {
    getDiscountRule();
  }, [filterStatus, pagination.currentPage, pagination.perPage]);
  
  const handlePageChange = ({ selected }) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: selected + 1,
    }));
  };

  const handlePerPageChange = (e) => {
    const newPerPage = parseInt(e.target.value);
    setPagination((prev) => ({
      ...prev,
      perPage: newPerPage,
      currentPage: 1,
    }));
  };
  // handle add discount  rule
  const handleDiscountRule = () => {
    setShowModal(true);
    resetForm();
  };
  // Fetch All Discount  Rules
  const getDiscountRule = async () => {
    setGetLoading(true);
    try {
      const response = await apiUrl.get("getDiscountRules", {
        params: {
          status: filterStatus,
          page: pagination.currentPage,
          perPage: pagination.perPage,
        },
      });
      if (response?.data?.status) {
        setDiscount(response.data.data || []);
        setCounts(response.data.counts);
        setPagination({
          currentPage: response.data.pagination.currentPage,
          perPage: response.data.pagination.perPage,
          total: response.data.pagination.total,
          lastPage: response.data.pagination.lastPage,
        });
      }
    } catch (error) {
      console.error("Failed to fetch discount rules:", error);
    } finally {
      setGetLoading(false);
    }
  };
  // handle reset form
  const resetForm = () => {
    setFormData({
      time: "",
      description: "",
      percentage: "",
      is_active: true,
    });
    setIsEditing(false);
  };

  // handle edit
  const handleEdit = async (discount) => {
    setFormData({ ...discount });
    setIsEditing(true);
    setShowModal(true);
  };

  // handle delete
  const handleDelete = async (discount) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to delete "${discount.title}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    try {
      const response = await apiUrl.post("deleteDiscountRule", {
        id: discount.id,
      });

      if (response.data.status) {
        invalidateInvoiceCatalog();
        getDiscountRule();
        Swal.fire({
          title: `Discount Rule "${discount.title}" deleted successfully!`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
          background: "#eef2f8",
          iconColor: "#435690",
        });
      }
    } catch (error) {
      console.error("Delete failed:", error);
      Swal.fire({
        title: "Failed to delete discount rule",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
        timer: 3000,
        showConfirmButton: true,
      });
    }
  };
  //  handle save discount record while create or edit
  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await apiUrl.post("createDiscountRule", formData);
      if (response?.status) {
        invalidateInvoiceCatalog();
        resetForm();
        setShowModal(false);
        Swal.fire({
          title: response?.data?.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          toast: true,
          position: "top-end",
          background: "#eef2f8",
          iconColor: "#435690",
        });
        getDiscountRule();
      }
    } catch (error) {
      console.error("Save failed:", error);
      Swal.fire({
        title: "Failed to create rule",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
        timer: 5000,
        showConfirmButton: true,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-fluid py-4">
      <div className="container">
        {/* Header */}
        <div
          className="card mb-4 shadow-sm border-0"
          style={{ background: "linear-gradient(90deg, #ffffff, #d2e8f8)" }}
        >
          <div className="card-body d-flex align-items-center">
            <div
              className="me-4 d-flex justify-content-center align-items-center rounded-circle"
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "#435690",
              }}
            >
              <i className="bi bi-gear-fill text-white fs-4"></i>
            </div>
            <div>
              <h1
                className="h3 mb-1 fw-bold text-dark"
                style={{ letterSpacing: "0.5px" }}
              >
                Discount Rules Management
              </h1>
              <p className="text-muted mb-0" style={{ fontSize: "0.95rem" }}>
                Define and manage discount rules (e.g., referral, early bird) to
                apply fixed percentage discounts on application fees.
              </p>
            </div>
          </div>
        </div>
        {/* Controls */}
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="d-flex flex-wrap align-items-center justify-content-end gap-3 mb-4">
              {/* Status Filter */}
              <div
                className="flex-grow-1 flex-md-grow-0"
                style={{ minWidth: "200px", maxWidth: "300px" }}
              >
                <select
                  className="form-select shadow-sm"
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  style={{ minHeight: "45px" }}
                >
                  <option value="all">All Status</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              {/* Add Rule Button */}
              <div>
                <button
                  className="btn btn-primary text-white d-inline-flex align-items-center"
                  data-bs-toggle="modal"
                  onClick={handleDiscountRule}
                >
                  <FaIcons.FaPlusCircle className="me-2" size={18} />
                  Add Discount Rule
                </button>
              </div>
            </div>

            {/* Stats Cards */}
            <div className="container px-3">
              <div
                className="d-flex flex-wrap"
                style={{
                  gap: "20px",
                }}
              >
                {/* Total Rules */}
                <div
                  className="card shadow-sm border-0"
                  style={{
                    width: "250px",
                    background: "linear-gradient(135deg, #edf2fb, #f7faff)",
                    borderRadius: "12px",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center h-100">
                    <div>
                      <p className="mb-1 fw-semibold text-primary">
                        Total Rules
                      </p>
                      <h4 className="mb-0">{counts?.total}</h4>
                    </div>
                    <div
                      className="bg-primary bg-opacity-10 rounded-circle d-flex justify-content-center align-items-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <FaIcons.FaCogs className="text-primary" />
                    </div>
                  </div>
                </div>

                {/* Active Rules */}
                <div
                  className="card shadow-sm border-0"
                  style={{
                    width: "250px",
                    background: "linear-gradient(135deg, #e7fdf3, #f0fffa)",
                    borderRadius: "12px",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center h-100">
                    <div>
                      <p className="mb-1 fw-semibold text-success">
                        Active Rules
                      </p>
                      <h4 className="mb-0">{counts?.active}</h4>
                    </div>
                    <div
                      className="bg-success bg-opacity-10 rounded-circle d-flex justify-content-center align-items-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <FaIcons.FaCheckCircle className="text-success" />
                    </div>
                  </div>
                </div>

                {/* In-Active Rules */}
                <div
                  className="card shadow-sm border-0"
                  style={{
                    width: "250px",
                    background: "linear-gradient(135deg, #f9dada, #f6c8cb)",
                    borderRadius: "12px",
                    padding: "20px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center h-100">
                    <div>
                      <p
                        className="mb-1 fw-semibold"
                        style={{ color: "#c62828" }}
                      >
                        Inactive Rules
                      </p>
                      <h4 className="mb-0">{counts?.inactive}</h4>
                    </div>
                    <div
                      className=" bg-opacity-10 rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "#f9dada",
                      }}
                    >
                      <FaIcons.FaCheckCircle style={{ color: "#c62828" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Rules Table */}
            <div className="table-responsive mt-4">
              <table className="table table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Percentage</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th className="text-end">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {getLoading ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {discount?.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            <div className="no-results">
                              <div className="no-results-icon">
                                <i className="bi bi-search fs-4"></i>
                              </div>
                              <p className="fw-medium">
                                No discount rules found
                              </p>
                              <p className="small">
                                Create your first discount rule to get started.
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        discount?.map((dis) => (
                          <tr key={dis.id}>
                            <td className="fw-medium">{dis.title}</td>
                            <td style={{ maxWidth: "250px" }}>
                              <span
                                className="d-inline-block text-truncate"
                                style={{ maxWidth: "100%" }}
                                title={dis.description}
                              >
                                {dis.description}
                              </span>
                            </td>
                            <td className="font-monospace">
                              {dis.percentage} %
                            </td>
                            <td>
                              <span
                                className="badge"
                                style={{
                                  backgroundColor: dis.is_active
                                    ? "#d2f3df"
                                    : "#f9dada",
                                  color: dis.is_active ? "#2e7d32" : "#c62828",
                                  fontWeight: "700",
                                  fontSize: "0.75rem",
                                  padding: "0.25em 0.5em",
                                  borderRadius: "0.375rem",
                                  whiteSpace: "nowrap",
                                  lineHeight: "1",
                                }}
                              >
                                {dis.is_active ? "Active" : "Inactive"}
                              </span>
                            </td>
                            <td className="text-muted">
                              {new Date(dis.created_at).toLocaleDateString()}
                            </td>
                            <td className="text-end">
                              <button
                                onClick={() => {
                                  handleEdit(dis);
                                }}
                                className="btn btn-outline-primary btn-sm me-2"
                              >
                                <FaIcons.FaPencilAlt className="me-1" />
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                  handleDelete(dis);
                                }}
                              >
                                <FaIcons.FaTrash className="me-1" />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pagination Section */}
          <div className="row align-items-center mb-5 mt-2">
            <div className="col-auto">
              <select
                value={pagination?.perPage}
                onChange={handlePerPageChange}
                className="form-select"
                style={{ minWidth: 80 }}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value={pagination?.total}>All</option>
              </select>
            </div>
            <div className="col-auto text-muted">
              Page {pagination?.currentPage} Showing{" "}
              {pagination?.perPage >= pagination?.total
                ? pagination?.total
                : pagination?.perPage}{" "}
              of {pagination?.total} entries
            </div>
            <div className="col">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pagination.lastPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                forcePage={pagination.currentPage - 1}
                containerClassName={"pagination justify-content-end mb-0"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                activeClassName={"active"}
                disabledClassName={"disabled"}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <DiscountRuleModal
        show={showModal}
        onClose={() => {
          resetForm();
          setShowModal(false);
        }}
        onSave={handleSave}
        loading={loading}
        formData={formData}
        setFormData={setFormData}
        isEditing={isEditing}
      />
    </div>
  );
}

export default DiscountRule;
